import React, { useState, useEffect } from "react";
import BotonManualHeader from "../../components/BotonManualHeader";
import { Container, Card, Button, Table, Modal, Form, Row, Col, Badge, Alert, Spinner, Tab, Tabs } from "react-bootstrap";
import { FaBus, FaRoute, FaPlus, FaEdit, FaTrash, FaMapMarkerAlt, FaFileExcel, FaSyncAlt } from "react-icons/fa";
import { collection, query, where, getDocs, doc, setDoc, deleteDoc, getFirestore, writeBatch } from "firebase/firestore";
import firebaseApp from "../../firebase/credenciales";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

const db = getFirestore(firebaseApp);

const GestionTransporte = ({ usuario }) => {
    const [key, setKey] = useState("rutas");
    const [rutas, setRutas] = useState([]);
    const [buses, setBuses] = useState([]);

    const [loading, setLoading] = useState(false);

    // Estados para Modales
    const [showModalRuta, setShowModalRuta] = useState(false);
    const [showModalBus, setShowModalBus] = useState(false);
    const [modoEdicion, setModoEdicion] = useState(false);
    const [itemSeleccionado, setItemSeleccionado] = useState(null);

    // Form Data Rutas
    const [rutaData, setRutaData] = useState({
        nombre: "",
        origen: "",
        origenLat: "",
        origenLng: "",
        destino: "",
        destinoLat: "",
        destinoLng: "",
        tarifaIngreso: "",
        tarifaSalida: "",
        puntosControl: [],
        busId: ""
    });

    // Form Data Buses
    const [busData, setBusData] = useState({
        placa: "",
        modelo: "",
        capacidad: "",
        empresaTransporte: "", // Nuevo campo
        estado: "activo",
        rutaDefectoId: ""
    });

    // Obtener RUC de empresa (fallback a usuario.ruc si rucEmpresa no existe)
    const rucEmpresa = usuario?.rucEmpresa || usuario?.ruc;

    useEffect(() => {
        console.log("GestionTransporte mounted/updated");
        console.log("RUC Empresa activo:", rucEmpresa);

        if (rucEmpresa) {
            cargarRutas();
            cargarBuses();
        } else {
            console.warn("ALERTA: No se encontró rucEmpresa ni ruc en el objeto usuario", usuario);
        }
    }, [usuario, key, rucEmpresa]);

    // --- LOGICA RUTAS ---
    const cargarRutas = async () => {
        try {
            setLoading(true);
            const rucEmpresaStr = String(rucEmpresa);
            console.log("Cargando rutas para RUC:", rucEmpresaStr);
            const q = query(collection(db, "rutas"), where("rucEmpresa", "==", rucEmpresaStr));
            const snapshot = await getDocs(q);
                        const rutasData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            console.log("Rutas encontradas:", rutasData.length);
            rutasData.sort((a, b) => (a.nombre || "").localeCompare(b.nombre || ""));
            setRutas(rutasData);
        } catch (error) {
            console.error("Error cargando rutas:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleGuardarRuta = async () => {
        try {
            if (!rutaData.nombre || !rutaData.origen || !rutaData.destino) {
                Swal.fire("Error", "Complete los campos obligatorios", "warning");
                return;
            }

            setLoading(true);
            const tarifaIngresoValue = rutaData.tarifaIngreso !== "" && rutaData.tarifaIngreso !== null && rutaData.tarifaIngreso !== undefined
                ? Number(rutaData.tarifaIngreso)
                : (rutaData.tarifa !== "" && rutaData.tarifa !== null && rutaData.tarifa !== undefined ? Number(rutaData.tarifa) : 0);
            const tarifaSalidaValue = rutaData.tarifaSalida !== "" && rutaData.tarifaSalida !== null && rutaData.tarifaSalida !== undefined
                ? Number(rutaData.tarifaSalida)
                : 0;

            const rutaPayload = {
                ...rutaData,
                origenLat: rutaData.origenLat ? parseFloat(rutaData.origenLat) : null,
                origenLng: rutaData.origenLng ? parseFloat(rutaData.origenLng) : null,
                destinoLat: rutaData.destinoLat ? parseFloat(rutaData.destinoLat) : null,
                destinoLng: rutaData.destinoLng ? parseFloat(rutaData.destinoLng) : null,
                tarifaIngreso: tarifaIngresoValue,
                tarifaSalida: tarifaSalidaValue,
                // Mantener campo legado para compatibilidad con otros módulos.
                tarifa: tarifaIngresoValue,
                rucEmpresa: String(rucEmpresa),
                fechaCreacion: new Date()
            };

            const docRef = modoEdicion && itemSeleccionado
                ? doc(db, "rutas", itemSeleccionado.id)
                : doc(collection(db, "rutas"));

            await setDoc(docRef, rutaPayload, { merge: true });

            Swal.fire("Éxito", "Ruta guardada correctamente", "success");
            setShowModalRuta(false);
            cargarRutas();
        } catch (error) {
            console.error("Error guardando ruta:", error);
            Swal.fire("Error", "No se pudo guardar la ruta", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleEliminarRuta = async (id) => {
        const result = await Swal.fire({
            title: "¿Eliminar ruta?",
            text: "Esta acción no se puede deshacer",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar"
        });

        if (result.isConfirmed) {
            try {
                await deleteDoc(doc(db, "rutas", id));
                cargarRutas();
                Swal.fire("Eliminado", "Ruta eliminada", "success");
            } catch (error) {
                console.error("Error eliminando ruta:", error);
            }
        }
    };

    // --- LOGICA BUSES ---
    const cargarBuses = async () => {
        try {
            setLoading(true);
            const rucEmpresaStr = String(rucEmpresa);
            console.log("Cargando buses para RUC:", rucEmpresaStr);
            const q = query(collection(db, "buses"), where("rucEmpresa", "==", rucEmpresaStr));
            const snapshot = await getDocs(q);
                        const busesData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            console.log("Buses encontrados:", busesData.length);
            busesData.sort((a, b) => (a.placa || "").localeCompare(b.placa || ""));
            setBuses(busesData);
        } catch (error) {
            console.error("Error cargando buses:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleGuardarBus = async () => {
        try {
            if (!busData.placa || !busData.modelo) {
                Swal.fire("Error", "Complete los campos obligatorios", "warning");
                return;
            }

            setLoading(true);
            const busPayload = {
                ...busData,
                capacidad: Number(busData.capacidad),
                rucEmpresa: String(rucEmpresa),
                empresaTransporte: busData.empresaTransporte || "", // Guardar nuevo campo
                fechaCreacion: new Date()
            };

            const docRef = modoEdicion && itemSeleccionado
                ? doc(db, "buses", itemSeleccionado.id)
                : doc(collection(db, "buses"));

            await setDoc(docRef, busPayload, { merge: true });

            Swal.fire("Éxito", "Bus guardado correctamente", "success");
            setShowModalBus(false);
            cargarBuses();
        } catch (error) {
            console.error("Error guardando bus:", error);
            Swal.fire("Error", "No se pudo guardar el bus", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleEliminarBus = async (id) => {
        const result = await Swal.fire({
            title: "¿Eliminar bus?",
            text: "Esta acción no se puede deshacer",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar"
        });

        if (result.isConfirmed) {
            try {
                await deleteDoc(doc(db, "buses", id));
                cargarBuses();
                Swal.fire("Eliminado", "Bus eliminado", "success");
            } catch (error) {
                console.error("Error eliminando bus:", error);
            }
        }
    };



    // --- LOGICA IMPORTACIÓN MASIVA ---
    const handleImportarExcel = (e, tipo) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = async (evt) => {
            try {
                const bstr = evt.target.result;
                const workbook = XLSX.read(bstr, { type: "binary" });
                const wsname = workbook.SheetNames[0];
                const ws = workbook.Sheets[wsname];
                const data = XLSX.utils.sheet_to_json(ws);

                if (data.length === 0) {
                    Swal.fire("Error", "El archivo está vacío", "error");
                    return;
                }

                setLoading(true);
                const batch = writeBatch(db);
                let count = 0;

                if (tipo === "rutas") {
                    data.forEach((row) => {
                        if (row.Nombre && row.Origen && row.Destino) {
                            const newDocRef = doc(collection(db, "rutas"));
                            batch.set(newDocRef, {
                                nombre: row.Nombre,
                                origen: row.Origen,
                                origenLat: row.OrigenLat ? parseFloat(row.OrigenLat) : null,
                                origenLng: row.OrigenLng ? parseFloat(row.OrigenLng) : null,
                                destino: row.Destino,
                                destinoLat: row.DestinoLat ? parseFloat(row.DestinoLat) : null,
                                destinoLng: row.DestinoLng ? parseFloat(row.DestinoLng) : null,
                                tarifaIngreso: row.TarifaIngreso !== undefined && row.TarifaIngreso !== null && row.TarifaIngreso !== ""
                                    ? Number(row.TarifaIngreso)
                                    : (row.Tarifa !== undefined && row.Tarifa !== null && row.Tarifa !== "" ? Number(row.Tarifa) : 0),
                                tarifaSalida: row.TarifaSalida !== undefined && row.TarifaSalida !== null && row.TarifaSalida !== ""
                                    ? Number(row.TarifaSalida)
                                    : 0,
                                tarifa: row.TarifaIngreso !== undefined && row.TarifaIngreso !== null && row.TarifaIngreso !== ""
                                    ? Number(row.TarifaIngreso)
                                    : (row.Tarifa !== undefined && row.Tarifa !== null && row.Tarifa !== "" ? Number(row.Tarifa) : 0),
                                puntosControl: [],
                                rucEmpresa: String(rucEmpresa),
                                fechaCreacion: new Date()
                            });
                            count++;
                        }
                    });
                } else if (tipo === "buses") {
                    // Pre-cargar mapa de rutas para asignación rápida
                    const mapaRutas = {};
                    rutas.forEach(r => mapaRutas[r.nombre.toLowerCase()] = r.id);

                    data.forEach((row) => {
                        if (row.Placa && row.Modelo && row.Capacidad) {
                            const newDocRef = doc(collection(db, "buses"));
                            let rutaId = "";

                            // Intentar asignar ruta si viene en el excel
                            if (row.Ruta) {
                                const rutaNombre = row.Ruta.toString().toLowerCase().trim();
                                if (mapaRutas[rutaNombre]) {
                                    rutaId = mapaRutas[rutaNombre];
                                }
                            }

                            batch.set(newDocRef, {
                                placa: row.Placa,
                                modelo: row.Modelo,
                                capacidad: Number(row.Capacidad),
                                empresaTransporte: row.Empresa || "", // Leer columna Empresa
                                estado: row.Estado ? row.Estado.toLowerCase() : "activo",
                                rutaDefectoId: rutaId,
                                rucEmpresa: String(rucEmpresa),
                                fechaCreacion: new Date()
                            });
                            count++;
                        }
                    });
                }

                if (count > 0) {
                    await batch.commit();
                    Swal.fire("Éxito", `Se importaron ${count} registros correctamente`, "success");
                    if (tipo === "rutas") cargarRutas();
                    if (tipo === "buses") cargarBuses();
                } else {
                    Swal.fire("Aviso", "No se encontraron registros válidos para importar. Verifique las columnas.", "warning");
                }

            } catch (error) {
                console.error("Error importando excel:", error);
                Swal.fire("Error", "Error al procesar el archivo Excel", "error");
            } finally {
                setLoading(false);
                e.target.value = null; // Reset input
            }
        };
        reader.readAsBinaryString(file);
    };

    // --- LOGICA DESCARGAR PLANTILLA ---
    const handleDescargarPlantilla = (tipo) => {
        let headers = [];
        let nombreArchivo = "";

        if (tipo === "rutas") {
            headers = [{ Nombre: "Ej. Ruta Norte", Origen: "Ej. Planta", Destino: "Ej. Centro", TarifaIngreso: 120, TarifaSalida: 120 }];
            nombreArchivo = "Plantilla_Rutas.xlsx";
        } else if (tipo === "buses") {
            headers = [{ Placa: "Ej. ABC-123", Modelo: "Ej. Volvo", Capacidad: 45, Empresa: "Ej. Transportes SAC", Estado: "activo", Ruta: "Ej. Ruta Norte" }];
            nombreArchivo = "Plantilla_Buses.xlsx";
        }

        const ws = XLSX.utils.json_to_sheet(headers);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Plantilla");
        XLSX.writeFile(wb, nombreArchivo);
    };

    // Helper para obtener nombre de ruta
    const getNombreRuta = (rutaId) => {
        const ruta = rutas.find(r => r.id === rutaId);
        return ruta ? ruta.nombre : "Sin Ruta Asignada";
    };

    // Helper para obtener info del bus
    const getNombreBus = (busId) => {
        const bus = buses.find(b => b.id === busId);
        return bus ? `${bus.placa} - ${bus.modelo}` : null;
    };

    return (
        <>
            <Container fluid className="py-4">
                <Card
                    className="shadow-lg border-0"
                    style={{ borderRadius: "15px", overflow: "hidden", minHeight: "90vh" }}
                >
                    {/* Header Premium con degradado verde oscuro */}
                    <Card.Header
                        className="text-white py-4 position-relative"
                        style={{
                            background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                            borderBottom: "3px solid #f39c12",
                            borderRadius: "15px 15px 0 0",
                        }}
                    >
                        <div
                            className="position-absolute end-0 top-50 translate-middle-y me-4"
                            style={{ zIndex: 10 }}
                        >
                            <BotonManualHeader usuario={usuario} />
                        </div>
                        <div className="text-center">
                            <h2 className="fw-bold mb-1">
                                <FaBus className="me-3" />
                                Gestión de Transporte
                            </h2>
                            <p className="mb-0 opacity-75">
                                Administra buses, rutas y tarifas del personal | RUC: {rucEmpresa}
                            </p>
                        </div>
                    </Card.Header>

                    <Card.Body className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
                        {/* Acciones Rápidas */}
                        <Card
                            className="border-0 mb-4"
                            style={{
                                background: "linear-gradient(135deg,#fffcea,#fff9db)",
                                borderRadius: 14,
                                boxShadow: "0 2px 12px rgba(109,40,217,.07)",
                            }}
                        >
                            <Card.Body className="p-3 d-flex justify-content-center gap-3 flex-wrap align-items-center">
                                {key === "rutas" && (
                                    <>
                                        <Button
                                            variant="outline-dark"
                                            onClick={() => handleDescargarPlantilla("rutas")}
                                            className="d-flex align-items-center gap-2 bg-white"
                                            style={{ borderRadius: "10px", fontWeight: "bold" }}
                                        >
                                            <FaFileExcel size="16px" />
                                            Plantilla Rutas
                                        </Button>
                                        <label
                                            className="btn btn-outline-dark d-flex align-items-center gap-2 bg-white mb-0"
                                            style={{
                                                borderRadius: "10px",
                                                fontWeight: "bold",
                                                cursor: "pointer",
                                            }}
                                        >
                                            <FaSyncAlt size="16px" />
                                            Importar Rutas
                                            <input
                                                type="file"
                                                hidden
                                                accept=".xlsx, .xls"
                                                onChange={(e) => handleImportarExcel(e, "rutas")}
                                            />
                                        </label>
                                        <Button
                                            variant="success"
                                            onClick={() => {
                                                setModoEdicion(false);
                                                setRutaData({
                                                    nombre: "",
                                                    origen: "",
                                                    origenLat: "",
                                                    origenLng: "",
                                                    destino: "",
                                                    destinoLat: "",
                                                    destinoLng: "",
                                                    tarifaIngreso: "",
                                                    tarifaSalida: "",
                                                    puntosControl: [],
                                                    busId: "",
                                                });
                                                setShowModalRuta(true);
                                            }}
                                            className="d-flex align-items-center gap-2"
                                            style={{
                                                borderRadius: "10px",
                                                background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                                                border: "none",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            <FaPlus size="16px" />
                                            Nueva Ruta
                                        </Button>
                                    </>
                                )}
                                {key === "buses" && (
                                    <>
                                        <Button
                                            variant="outline-dark"
                                            onClick={() => handleDescargarPlantilla("buses")}
                                            className="d-flex align-items-center gap-2 bg-white"
                                            style={{ borderRadius: "10px", fontWeight: "bold" }}
                                        >
                                            <FaFileExcel size="16px" />
                                            Plantilla Buses
                                        </Button>
                                        <label
                                            className="btn btn-outline-dark d-flex align-items-center gap-2 bg-white mb-0"
                                            style={{
                                                borderRadius: "10px",
                                                fontWeight: "bold",
                                                cursor: "pointer",
                                            }}
                                        >
                                            <FaSyncAlt size="16px" />
                                            Importar Buses
                                            <input
                                                type="file"
                                                hidden
                                                accept=".xlsx, .xls"
                                                onChange={(e) => handleImportarExcel(e, "buses")}
                                            />
                                        </label>
                                        <Button
                                            variant="success"
                                            onClick={() => {
                                                setModoEdicion(false);
                                                setBusData({
                                                    placa: "",
                                                    modelo: "",
                                                    capacidad: "",
                                                    empresaTransporte: "",
                                                    estado: "activo",
                                                    rutaDefectoId: "",
                                                });
                                                setShowModalBus(true);
                                            }}
                                            className="d-flex align-items-center gap-2"
                                            style={{
                                                borderRadius: "10px",
                                                background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                                                border: "none",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            <FaPlus size="16px" />
                                            Nuevo Bus
                                        </Button>
                                    </>
                                )}
                            </Card.Body>
                        </Card>

                        <Tabs
                            id="transport-tabs"
                            activeKey={key}
                            onSelect={(k) => setKey(k)}
                            className="mb-4"
                        >
                            <Tab eventKey="rutas" title="Rutas">
                                <div className="table-responsive bg-white rounded-4 shadow-sm p-3">
                                    <Table striped hover className="mb-0 align-middle">
                                        <thead>
                                            <tr>
                                                <th className="border-0">Nombre Ruta</th>
                                                <th className="border-0">Origen</th>
                                                <th className="border-0">Destino</th>
                                                <th className="border-0">Tarifa de Ingreso</th>
                                                <th className="border-0">Tarifa de Salida</th>
                                                <th className="border-0">Bus Asignado</th>
                                                <th className="border-0 text-center">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rutas.map((ruta) => (
                                                <tr key={ruta.id}>
                                                    <td className="fw-bold">{ruta.nombre}</td>
                                                    <td>{ruta.origen}</td>
                                                    <td>{ruta.destino}</td>
                                                    <td className="text-success fw-bold">
                                                        S/ {Number(ruta.tarifaIngreso ?? ruta.tarifa ?? 0).toFixed(2)}
                                                    </td>
                                                    <td className="text-primary fw-bold">
                                                        S/ {Number(ruta.tarifaSalida || 0).toFixed(2)}
                                                    </td>
                                                    <td>
                                                        {ruta.busId ? (
                                                            <Badge
                                                                bg="light"
                                                                text="dark"
                                                                className="border"
                                                                style={{ padding: "8px 12px", borderRadius: "8px" }}
                                                            >
                                                                <FaBus className="me-2 text-primary" />
                                                                {getNombreBus(ruta.busId) || ruta.busId}
                                                            </Badge>
                                                        ) : (
                                                            <span className="text-muted small">Sin asignar</span>
                                                        )}
                                                    </td>
                                                    <td className="text-center">
                                                        <div className="d-flex justify-content-center gap-2">
                                                            <Button
                                                                variant="light"
                                                                className="btn-action shadow-sm"
                                                                onClick={() => {
                                                                    setModoEdicion(true);
                                                                    setItemSeleccionado(ruta);
                                                                    setRutaData({
                                                                        ...ruta,
                                                                        busId: ruta.busId || "",
                                                                        tarifaIngreso: ruta.tarifaIngreso ?? ruta.tarifa ?? "",
                                                                        tarifaSalida: ruta.tarifaSalida ?? "",
                                                                    });
                                                                    setShowModalRuta(true);
                                                                }}
                                                            >
                                                                <FaEdit className="text-warning" />
                                                            </Button>
                                                            <Button
                                                                variant="light"
                                                                className="btn-action shadow-sm"
                                                                onClick={() => handleEliminarRuta(ruta.id)}
                                                            >
                                                                <FaTrash className="text-danger" />
                                                            </Button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                            {rutas.length === 0 && (
                                                <tr>
                                                    <td colSpan="7" className="text-center text-muted py-5">
                                                        <div className="d-flex flex-column align-items-center opacity-50">
                                                            <FaRoute size="40px" className="mb-2" />
                                                            <span>No hay rutas registradas</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </Tab>

                            <Tab eventKey="buses" title="Buses">
                                <div className="d-flex justify-content-end mb-3">
                                    <div className="d-flex gap-2">
                                        <Button
                                            variant="outline-success"
                                            onClick={() => handleDescargarPlantilla("buses")}
                                            title="Descargar Plantilla"
                                        >
                                            <FaFileExcel />
                                        </Button>
                                        <label className="btn btn-success">
                                            Importar <input type="file" hidden accept=".xlsx, .xls" onChange={(e) => handleImportarExcel(e, "buses")} />
                                        </label>
                                        <Button
                                            variant="primary"
                                            onClick={() => {
                                                setModoEdicion(false);
                                                setBusData({ placa: "", modelo: "", capacidad: "", empresaTransporte: "", estado: "activo", rutaDefectoId: "" });
                                                setShowModalBus(true);
                                            }}
                                        >
                                            <FaPlus className="me-2" /> Nuevo Bus
                                        </Button>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <Table striped hover className="mb-0">
                                        <thead className="bg-light">
                                            <tr>
                                                <th>Placa</th>
                                                <th>Modelo</th>
                                                <th>Empresa</th>
                                                <th>Capacidad</th>
                                                <th>Estado</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {buses.map(bus => (
                                                <tr key={bus.id}>
                                                    <td>{bus.placa}</td>
                                                    <td>{bus.modelo}</td>
                                                    <td>{bus.empresaTransporte || <span className="text-muted fst-italic">Propio</span>}</td>
                                                    <td>{bus.capacidad} pax</td>
                                                    <td>
                                                        <Badge bg={bus.estado === 'activo' ? 'success' : 'secondary'}>
                                                            {bus.estado.toUpperCase()}
                                                        </Badge>
                                                    </td>
                                                    <td>
                                                        <Button variant="link" className="text-warning p-0 me-3" onClick={() => {
                                                            setModoEdicion(true);
                                                            setItemSeleccionado(bus);
                                                            setBusData(bus);
                                                            setShowModalBus(true);
                                                        }}><FaEdit size={18} /></Button>
                                                        <Button variant="link" className="text-danger p-0" onClick={() => handleEliminarBus(bus.id)}><FaTrash size={18} /></Button>
                                                    </td>
                                                </tr>
                                            ))}
                                            {buses.length === 0 && (
                                                <tr>
                                                    <td colSpan="5" className="text-center text-muted py-4">
                                                        No hay buses registrados
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </Tab>


                        </Tabs>
                    </Card.Body>
                </Card>
            </Container >

            {/* Modal Ruta */}
            < Modal show={showModalRuta} onHide={() => setShowModalRuta(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{modoEdicion ? "Editar Ruta" : "Nueva Ruta"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Nombre de la Ruta</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Ej: Ruta Norte - Planta"
                                value={rutaData.nombre}
                                onChange={(e) => setRutaData({ ...rutaData, nombre: e.target.value })}
                            />
                        </Form.Group>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Origen</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Ej: Plaza Norte"
                                        value={rutaData.origen}
                                        onChange={(e) => setRutaData({ ...rutaData, origen: e.target.value })}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Latitud Origen</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="-12.000000"
                                        value={rutaData.origenLat}
                                        onChange={(e) => setRutaData({ ...rutaData, origenLat: e.target.value })}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Longitud Origen</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="-77.000000"
                                        value={rutaData.origenLng}
                                        onChange={(e) => setRutaData({ ...rutaData, origenLng: e.target.value })}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Destino</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Ej: Sede Central"
                                        value={rutaData.destino}
                                        onChange={(e) => setRutaData({ ...rutaData, destino: e.target.value })}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Latitud Destino</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="-12.000000"
                                        value={rutaData.destinoLat}
                                        onChange={(e) => setRutaData({ ...rutaData, destinoLat: e.target.value })}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Longitud Destino</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="-77.000000"
                                        value={rutaData.destinoLng}
                                        onChange={(e) => setRutaData({ ...rutaData, destinoLng: e.target.value })}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Form.Group className="mb-3">
                            <Form.Label>Tarifa de Ingreso</Form.Label>
                            <Form.Control
                                type="number"
                                min="0"
                                step="0.01"
                                placeholder="Ej: 120.50"
                                value={rutaData.tarifaIngreso}
                                onChange={(e) => setRutaData({ ...rutaData, tarifaIngreso: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Tarifa de Salida</Form.Label>
                            <Form.Control
                                type="number"
                                min="0"
                                step="0.01"
                                placeholder="Ej: 120.50"
                                value={rutaData.tarifaSalida}
                                onChange={(e) => setRutaData({ ...rutaData, tarifaSalida: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label><FaBus className="me-2" />Bus Asignado (Opcional)</Form.Label>
                            <Form.Select
                                value={rutaData.busId}
                                onChange={(e) => setRutaData({ ...rutaData, busId: e.target.value })}
                            >
                                <option value="">Seleccionar Bus...</option>
                                {buses.map(bus => (
                                    <option key={bus.id} value={bus.id}>
                                        {bus.placa} - {bus.modelo} ({bus.capacidad} pax)
                                    </option>
                                ))}
                            </Form.Select>
                            <Form.Text className="text-muted">Un bus puede tener múltiples rutas asignadas.</Form.Text>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalRuta(false)}>Cancelar</Button>
                    <Button variant="primary" onClick={handleGuardarRuta}>Guardar</Button>
                </Modal.Footer>
            </Modal >

            {/* Modal Bus */}
            < Modal show={showModalBus} onHide={() => setShowModalBus(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{modoEdicion ? "Editar Bus" : "Nuevo Bus"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Placa</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Ej: ABC-123"
                                        value={busData.placa}
                                        onChange={(e) => setBusData({ ...busData, placa: e.target.value })}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Capacidad</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Ej: 45"
                                        value={busData.capacidad}
                                        onChange={(e) => setBusData({ ...busData, capacidad: e.target.value })}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Form.Group className="mb-3">
                            <Form.Label>Modelo</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Ej: Volvo 9700"
                                value={busData.modelo}
                                onChange={(e) => setBusData({ ...busData, modelo: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Empresa de Transporte (Proveedor)</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Ej: Transportes y Servicios S.A.C."
                                value={busData.empresaTransporte}
                                onChange={(e) => setBusData({ ...busData, empresaTransporte: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Estado</Form.Label>
                            <Form.Select
                                value={busData.estado}
                                onChange={(e) => setBusData({ ...busData, estado: e.target.value })}
                            >
                                <option value="activo">Activo</option>
                                <option value="mantenimiento">Mantenimiento</option>
                                <option value="inactivo">Inactivo</option>
                            </Form.Select>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalBus(false)}>Cancelar</Button>
                    <Button variant="primary" onClick={handleGuardarBus}>Guardar</Button>
                </Modal.Footer>
            </Modal >
        </>
    );

};

export default GestionTransporte;
